import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { pageStartEventBuilder, sendEvent } from "../utils/event-helpers";
import { useAppDispatch, useAppSelector } from "../app/store";

export function RouteTracker() {
  const location = useLocation();
  const { userId, sessionId } = useAppSelector((state) => state.session);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!userId || !sessionId) return;

    const pageEvent = pageStartEventBuilder(
      userId,
      sessionId,
      window.location.origin + location.pathname,
    );
    void dispatch(sendEvent(pageEvent));
  }, [location.pathname, userId, sessionId, dispatch]);

  return null;
}
